// extracted by mini-css-extract-plugin
module.exports = {"container":"PractitionersList_container__2dIHO","item":"PractitionersList_item__20Sg4","itemsContainer":"PractitionersList_itemsContainer__1Qdd7"};